import { IncomeSourceNicknameInput } from './IncomeSourceNicknameInput';
import { IncomeSourceIncomeTypeDropdown } from './IncomeSourceIncomeTypeDropdown';
import { isFutureIncomeSource } from '../util';
import { IncomeSourceIncomeAmountInput } from './IncomeSourceIncomeAmountInput';
import { IncomeSourceStartDate } from './IncomeSourceStartDate';
import { IncomeSourceOwnerDropdown } from './IncomeSourceOwnerDropdown';
import { IncomeSourceNotesTextArea } from './IncomeSourceNotesTextArea';
import { useState } from 'react';
import { ElementsButton, SideOverFooter } from '../../UI';
import { useTranslation } from 'react-i18next';
import { IncomeSourceType } from '../../generated/graphql';
import { useFeatureFlagsContext } from '../../FeatureFlags';
import { SMTailwindMinPixelBreakpointWidth } from '../../util/theme.util';
import { useMediaQuery } from '@mui/material';

interface IncomeSourceFormProps {
  firmID: string;
  clientID: string;
  loading: boolean;
}

export const StandardIncomeSourceForm = ({ firmID, clientID, loading }: IncomeSourceFormProps) => {
  const { t: tCommon } = useTranslation('common');
  const [incomeSource, setIncomeSource] = useState<IncomeSourceType | null>(null);
  const { showFutureIncome } = useFeatureFlagsContext();
  const isSmall = useMediaQuery(`(max-width: ${SMTailwindMinPixelBreakpointWidth}px)`);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_218px] gap-4">
        <IncomeSourceNicknameInput />
        <IncomeSourceIncomeTypeDropdown onSelectionChange={(value) => setIncomeSource(value)} />
      </div>

      {showFutureIncome && incomeSource && isFutureIncomeSource(incomeSource) ? (
        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
            <IncomeSourceIncomeAmountInput />
            <IncomeSourceStartDate />
          </div>
          <div className="mt-4">
            <IncomeSourceOwnerDropdown firmID={firmID} clientID={clientID} dropdownMenuClassName="!w-[284px]" />
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          <IncomeSourceIncomeAmountInput />
          <IncomeSourceOwnerDropdown firmID={firmID} clientID={clientID} dropdownMenuClassName="!w-[284px]" />
        </div>
      )}

      <IncomeSourceNotesTextArea className="mt-4 mb-20" />
      <SideOverFooter>
        <ElementsButton
          type="submit"
          theme="primary"
          isLoading={loading}
          icon="check"
          label={tCommon('save')}
          iconPosition={'left'}
          size={isSmall ? 'small' : 'large'}
        />
      </SideOverFooter>
    </>
  );
};
